import config from 'constants/config'
import { CRUISE_SERVICE_FEE_PERCENTAGE, DEFAULT_DEPOSIT_AMOUNT_PERCENTAGE, CS_DEPOSIT_PERCENTAGE_OVERRIDE, SERVICE_FEE_PERCENTAGE } from 'constants/payment'
import createSelector from 'lib/createSelector'
import { isCruiseItem } from 'lib/checkout'

const DISABLE_KEY = 'disable_service_fee'

export const getDefaultDepositAmountPercentage = createSelector(
  (state: App.State) => state.auth.account.isSpoofed,
  (state: App.State) => state.checkout.csDepositPercentageOverride,
  (isSpoofed, csDepositPercentageOverride): number => csDepositPercentageOverride && isSpoofed ? CS_DEPOSIT_PERCENTAGE_OVERRIDE : DEFAULT_DEPOSIT_AMOUNT_PERCENTAGE,
)

export const getDepositServiceFeeConfig = createSelector(
  (state: App.State) => state.config.originalCanonicalURL,
  (state: App.State) => state.checkout.cart.items,
  (url = '', items): App.Checkout.ServiceFeeSettings => {
    const queryString = url.slice(url.indexOf('?') + 1)
    const params = new URLSearchParams(queryString)
    const isEnabled = params.get(DISABLE_KEY) !== 'true'

    const cruiseItemExists = items.find(isCruiseItem)
    const percentage = cruiseItemExists ?
        (!isNaN(config.CRUISE_SERVICE_FEE_PERCENTAGE) ? Number(config.CRUISE_SERVICE_FEE_PERCENTAGE) : CRUISE_SERVICE_FEE_PERCENTAGE) :
      SERVICE_FEE_PERCENTAGE

    return {
      isEnabled: isEnabled && (percentage !== 0),
      percentage,
    }
  },
)
